const config = {
  routes: {
    label: 'FAQs',
    prefix: '/faq',
  },
}

export default config
